<template>
  <section class="aui-scrollView" style="background:#fff">
    <div class="header-nav">
      <div class="left">
        <a href="#" class="lk-back">返回</a>
      </div>
    </div>

    <div class="ts-wrap">
      <div class="success">
        <h4>
          <strong>600</strong>阅币充值完成！
        </h4>
      </div>

      <div class="btnbox">
        <button type="button" class="btn">去看漫画</button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'purchase-success',
  data () {
    return {}
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    }
  },
  mounted () {
    this.$router.isBack = true
  }
}
</script>

<style scoped>
</style>
